import { APPLICATION_STATUSES } from '../enums/application-statuses.enum';

export class ApplicationConstants {
	static ACTIVE_STATUS: Array<APPLICATION_STATUSES> = [
		APPLICATION_STATUSES.saved,
		APPLICATION_STATUSES.forwardedToHrForReview,
		APPLICATION_STATUSES.pendingReview,
		APPLICATION_STATUSES.incomplete,
		APPLICATION_STATUSES.approved,
		APPLICATION_STATUSES.forwardedToSupervisor,
		APPLICATION_STATUSES.virtualCreditCardIssued,
		APPLICATION_STATUSES.carryoverPaymentApproved,
		APPLICATION_STATUSES.materialsSent,
		APPLICATION_STATUSES.resendMaterials,
		APPLICATION_STATUSES.locIssued,
		APPLICATION_STATUSES.paymentReview,
		APPLICATION_STATUSES.paymentProcessingIncomplete,
		APPLICATION_STATUSES.paymentInProgress,
		APPLICATION_STATUSES.paymentApproved,
		APPLICATION_STATUSES.paymentComplete,
		APPLICATION_STATUSES.paymentCompleteCompletionDocumentsRequired,
		APPLICATION_STATUSES.repaymentRequired,
		APPLICATION_STATUSES.sentToCollections,
		APPLICATION_STATUSES.certificateIssued,
		APPLICATION_STATUSES.denied,
		APPLICATION_STATUSES.noPaymentProcessing
	];

	static SUPERVISOR_REVIEW_APPS_STATUS: Array<APPLICATION_STATUSES> = [APPLICATION_STATUSES.forwardedToSupervisor];

	static NON_GRADUATION_STATUSES: Array<APPLICATION_STATUSES> = [
		APPLICATION_STATUSES.forwardedToSupervisor,
		APPLICATION_STATUSES.incomplete,
		APPLICATION_STATUSES.pendingReview,
		APPLICATION_STATUSES.saved
	];

	static readonly ACTIVE_STATUS_WITH_OPEN_APPEAL: Array<APPLICATION_STATUSES> = [
		APPLICATION_STATUSES.saved,
		APPLICATION_STATUSES.forwardedToHrForReview,
		APPLICATION_STATUSES.pendingReview,
		APPLICATION_STATUSES.incomplete,
		APPLICATION_STATUSES.approved,
		APPLICATION_STATUSES.forwardedToSupervisor,
		APPLICATION_STATUSES.virtualCreditCardIssued,
		APPLICATION_STATUSES.carryoverPaymentApproved,
		APPLICATION_STATUSES.materialsSent,
		APPLICATION_STATUSES.resendMaterials,
		APPLICATION_STATUSES.locIssued,
		APPLICATION_STATUSES.paymentReview,
		APPLICATION_STATUSES.paymentProcessingIncomplete,
		APPLICATION_STATUSES.paymentInProgress,
		APPLICATION_STATUSES.paymentApproved,
		APPLICATION_STATUSES.paymentComplete,
		APPLICATION_STATUSES.paymentCompleteCompletionDocumentsRequired,
		APPLICATION_STATUSES.repaymentRequired,
		APPLICATION_STATUSES.sentToCollections,
		APPLICATION_STATUSES.certificateIssued,
		APPLICATION_STATUSES.noPaymentProcessing,
		APPLICATION_STATUSES.appealPendingReview,
		APPLICATION_STATUSES.appealInComplete,
		APPLICATION_STATUSES.appeal
	];
}
